type AllowedEnvironments = "staging" | "stage1" | "stage2" | "stage3" | "stage4" | "unknown";
export function getReleaseInfo(): { release: string, environment: AllowedEnvironments, enabled: boolean } {
	const url = new URL(window.location.href);

	let stage = url.searchParams.get("stage");
	if (!(["staging", "stage1", "stage2", "stage3", "stage4"].includes(stage))) {
		console.warn(`Unsupported stage: ${stage}, defaulting to unknown`);
		stage = "unknown";
	}

	const isEnabled = stage !== "unknown" || url.searchParams.get("enableSentry") === "true";

	//strip last and first "/", then split the rest of pathname, end result should look like this: [...somePathsNames, "online", "63"]
	const paths = url.pathname.replace(/^\//, "").replace(/\/$/, "").split("/");
	if (paths.length < 2) {
		console.warn("Can't get release info from URL, defaulting to unknown");
		return {
			release: "unknown",
			environment: stage as AllowedEnvironments,
			enabled: isEnabled,
		};
	}
	const release = paths.at(-2);
	const buildNumber = paths.at(-1);
	return {
		release: release + "-" + buildNumber,
		environment: stage as AllowedEnvironments,
		enabled: isEnabled,
	};
}